import React from "react";
import { LayoutDashboardIcon, FileSignatureIcon, MessageSquareIcon, LockIcon } from "lucide-react";
import { clientSpaceFeatures } from "../../data/home";
import { ClientDashboardPreview } from "./ClientDashboardPreview";
const icons = [LayoutDashboardIcon, FileSignatureIcon, MessageSquareIcon];
export function ClientSpace() {
  return <section id="espace-client" className="scroll-mt-24 px-3 py-3 md:px-5 md:py-5" data-id="element-36" data-mp="1j1b1sff2kk2t">
      <div className="mx-auto max-w-[1400px] rounded-[32px] bg-night px-5 py-20 md:rounded-[44px] md:px-12 md:py-28" data-id="element-37" data-mp="26ryjfseseo2k">
        <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-38" data-mp="2arfqurdrxvad">
          <div className="lg:col-span-5" data-id="element-39" data-mp="1ws7tm4168x8t">
            <p className="flex items-center gap-2 text-[15px] font-medium text-canvas/60" data-id="element-40" data-mp="21r16bu8mwk7x">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="ldkg5cpaccnm" />
              Espace client sécurisé
            </p>
            <h2 className="mt-3 text-4xl font-semibold leading-[1.05] tracking-tightest text-canvas md:text-[56px]" data-id="element-42" data-mp="qcnmr1kwyqxp">
              Votre patrimoine, suivi au quotidien.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-canvas/65" data-id="element-43" data-mp="rmbsp7bgr7sx">
              Retrouvez l’ensemble de vos contrats, leurs performances et vos documents dans un
              seul espace, accessible à tout moment.
            </p>

            <ul className="mt-10 space-y-6" data-id="element-44" data-mp="10lyuhu83ufmi">
              {clientSpaceFeatures.map((f, i) => {
              const Icon = icons[i];
              return <li key={f.title} className="flex gap-4" data-id="element-45" data-mp="1alfwa0k8k9d7" data-mpi={i}>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-night-card text-canvas" data-id="element-46" data-mp="1aitoq0xchtuz">
                      <Icon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-47" data-mp="1jdhvjvikjjlw" />
                    </span>
                    <div data-id="element-48" data-mp="1y9z4kg3acm5a">
                      <h3 className="font-semibold text-canvas" data-id="element-49" data-mp="1ybjwdxy7tqzg">{f.title}</h3>
                      <p className="mt-1 text-[15px] leading-relaxed text-canvas/60" data-id="element-50" data-mp="1tbxjjpmaucr6">{f.text}</p>
                    </div>
                  </li>;
            })}
            </ul>

            <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-51" data-mp="25d5ml3qj90d4">
              <a href="#" className="whitespace-nowrap rounded-full bg-canvas px-6 py-3.5 text-center text-[15px] font-medium text-ink transition-transform duration-150 active:scale-[0.97]" data-id="element-52" data-mp="25bcerl46oa3j">
                Accéder à mon espace
              </a>
              <a href="#" className="whitespace-nowrap rounded-full border border-night-line px-6 py-3.5 text-center text-[15px] font-medium text-canvas transition-colors duration-150 hover:border-canvas/40" data-id="element-53" data-mp="2k4nzgso3ies9">
                Créer mon compte
              </a>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-54" data-mp="yps31p78a59m">
            <ClientDashboardPreview data-id="element-55" data-mp="yr343h9agyx1" />
          </div>
        </div>
      </div>
    </section>;
}